import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const LoadingFallback = ({ linear = false }) => (
  <Box
    style={{
      display: "flex",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      height: 100,
    }}
  >
    {linear ? (
      <LinearProgress style={{ width: "100%" }} />
    ) : (
      <CircularProgress />
    )}
  </Box>
);

export default LoadingFallback;
